import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";

import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";

import { HomeComponent } from "./home.component";
import { DashboardModule } from "../shared/modules/dashboard/dashboard.module";
import { DatePickerModule } from "../shared/modules/datepicker-range/datepicker-range.module";
import { TabDatepickerModule } from "../shared/modules/tab-datepicker/tab-datepicker.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FlexLayoutModule,
    MatTabsModule,
    MatCardModule,
    MatIconModule,
    DashboardModule,
    TabDatepickerModule,
    DatePickerModule,
  ],
  declarations: [
    HomeComponent,
  ],
})
export class HomeModule {}
